import pino, { Logger, LoggerOptions } from 'pino';

const logLevelMap = {
  admin: 'info',
  server: 'info',
  'rest-api': 'debug',
  'analytics-rest-api': 'debug',
  'user-rest-api': 'debug',
  client: 'info',
  'app-api': 'info',
  auth: 'info',
  middleware: 'debug',
  s3: 'info',
  live: 'debug',
  elastic: 'info',
  sqs: 'debug',
  payload: 'debug',
  weather: 'debug',
  stripe: 'info',
  'live-api': 'debug',
};

function getLogLevel(logger: keyof typeof logLevelMap): string {
  return logLevelMap[logger] || 'info';
}

export function getLogger(
  name: keyof typeof logLevelMap,
  loggerOptions?: Omit<LoggerOptions, 'name' | 'level'>
): Logger {
  return pino({ name, level: getLogLevel(name), ...loggerOptions });
}

export type { Logger, LoggerOptions };
